import { render, staticRenderFns } from "./ChatInfoMembers.vue?vue&type=template&id=5e79f56f&scoped=true&"
import script from "./ChatInfoMembers.vue?vue&type=script&lang=js&"
export * from "./ChatInfoMembers.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoMembers.vue?vue&type=style&index=0&id=5e79f56f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79f56f",
  null
  
)

export default component.exports